import Axios from 'axios';
import { postWithSecureCredentials } from './securePost';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const getUserFromEmail = async (email) => {
	email = email.toLowerCase();
	return await postWithSecureCredentials(SERVER_URL + 'getUserFromEmail', {
		userEmail: email,
	})
		.then((response) => {
			return response.data.data;
		})
		.catch((err) => {
			console.log(err)
			if (err.response.data.errormsg === 'User Not Found') {
				throw new Error('User Not Found');
			} else {
				throw new Error('Error getting user from email');
			}
		});
};

// tokenID is the ID of the current user, emailID is the ID of the user whose email we want
export const getEmailFromId = async (tokenID, emailID) => {
	return await postWithSecureCredentials(SERVER_URL + 'getEmailFromId', {
		user_id: tokenID,
		email_id: emailID ? emailID : tokenID,
	})
		.then((response) => {
			return response.data.data.userEmail;
		})
		.catch((err) => {
			if (err.response.data.error === "Error: Could Not Get ID") {
				throw new Error("Error: Could Not Get ID");
			} else {
				throw new Error('Error getting ID from email');
			}
		});
};

//module.exports = { getUserFromEmail, getUserFromSecondIndex };
